import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Configuration multi-tenant.
 * Chaque clé = sous-domaine (ex: "idagray" pour idagray.quantelys.com)
 *
 * Ces tenants hardcodés servent de FALLBACK pour un chargement instantané
 * sans flash. Les nouveaux tenants sont chargés dynamiquement depuis le backend.
 */

const TENANTS = {
  idagray: {
    slug: "idagray",
    backendSlug: "ida-gray",
    name: "Centre Dentaire Ida Gray",
    shortName: "Ida Gray",
    logo: "/logos/idagray.png",
    brand: "#996B2F",
    brandHover: "#7A5526",
    brandMuted: "#F5EDE3",
    bg: "#FAF7F4",
    textPrimary: "#1A1714",
    textSecondary: "#5C4F42",
    textMuted: "#8C7B6A",
    borderSoft: "#E8E0D8",
    themeColor: "#996B2F",
    description: "Gestion des stocks — Centre Dentaire Ida Gray",
  },
  pharmacieespacesud: {
    slug: "pharmacieespacesud",
    backendSlug: "pharmacie-espace-sud",
    name: "Pharmacie de l'Espace Sud",
    shortName: "Espace Sud",
    logo: "/logos/pharmacieespacesud.svg",
    brand: "#3A8C3F",
    brandHover: "#2D6E31",
    brandMuted: "#E5F0E6",
    bg: "#F5FAF5",
    textPrimary: "#1A1F1A",
    textSecondary: "#3E4F3E",
    textMuted: "#6A8C6A",
    borderSoft: "#D8E8D8",
    themeColor: "#3A8C3F",
    description: "Gestion des stocks — Pharmacie de l'Espace Sud",
  },
};

// Valeurs par défaut (fallback si sous-domaine inconnu)
const DEFAULT_TENANT = TENANTS.idagray;

/**
 * Détecte le tenant à partir du hostname.
 * idagray.quantelys.com → "idagray"
 * pharmacieespacesud.quantelys.com → "pharmacieespacesud"
 * localhost → défaut (idagray)
 */
export function detectTenant() {
  const hostname = window.location.hostname;

  // Localhost / dev → vérifier query param ?tenant=xxx
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const params = new URLSearchParams(window.location.search);
    const tenantParam = params.get("tenant");
    if (tenantParam && TENANTS[tenantParam]) {
      return TENANTS[tenantParam];
    }
    return DEFAULT_TENANT;
  }

  // Production → sous-domaine
  const subdomain = hostname.split(".")[0];
  return TENANTS[subdomain] || DEFAULT_TENANT;
}

/**
 * Charge la config d'un tenant depuis le backend.
 * Retourne { found: true, ...config } ou { found: false }.
 */
export async function fetchTenantConfig(slug) {
  try {
    const res = await axios.get(`${BACKEND_URL}/api/auth/tenant-config/${slug}`);
    return res.data;
  } catch (err) {
    // 404 ou erreur réseau → tenant non trouvé
    if (err.response && err.response.status === 404) {
      return { found: false };
    }
    // Erreur réseau — on laisse le fallback gérer
    console.warn("[fetchTenantConfig] Erreur réseau:", err.message);
    return { found: false, networkError: true };
  }
}

export { TENANTS, DEFAULT_TENANT };
